import React, { useState } from 'react';
import { FiMoreVertical } from 'react-icons/fi';

import PopOver from 'components/common/popover';
import ChangeAppraiserModal from 'components/common/changeAppraiserModal';

import { CHANGE_APPRAISER } from 'constants/dashboard';
import { mixPanelEvents } from 'constants/mixPanel';
import * as mixpanel from 'services/mixPanel';

import type { TeamAllocationItem } from '../types';

const NullTrigger: React.FC<{ onClick: () => void; interactive: boolean; isLoading?: boolean }> = () => null;

interface ActionCellContentProps {
  /** Allocations where the viewer is the appraiser. Empty => no action for this row. */
  filteredAllocation: TeamAllocationItem[];
}

// TODO: Add the Change Leave Issuer as well after confirming how to
const ActionCellContent = ({ filteredAllocation }: ActionCellContentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  if (!filteredAllocation.length) {
    return null;
  }

  const modalAllocations = filteredAllocation.map((allocation) => ({
    name: allocation.name ?? '',
    id: allocation.id ?? 0,
  }));

  const handleChangeAppraiserClick = () => {
    setIsPopoverOpen(false);
    setIsModalOpen(true);
    mixpanel.trackEvent(mixPanelEvents.select.appraiserChangeRequest.linkFromMyTeamDashboard);
  };

  return (
    <div className="mr-10">
      <ChangeAppraiserModal
        TriggerBtn={NullTrigger}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        filteredAllocation={modalAllocations}
      />

      <PopOver
        interactive
        hideOnClick
        useContext={false}
        trigger="click"
        position="left"
        theme={'custom-light' as 'light'}
        color="white"
        customClass="my-team-action"
        open={isPopoverOpen}
        onShow={() => setIsPopoverOpen(true)}
        onRequestClose={() => setIsPopoverOpen(false)}
        html={
          <div className="d-flex flex-column my-team-menu">
            <button
              type="button"
              className="my-team-menu__item"
              style={{ padding: '12px 8px' }}
              onClick={handleChangeAppraiserClick}
            >
              {CHANGE_APPRAISER}
            </button>
          </div>
        }
      >
        <button type="button" className="btn action-btn">
          <FiMoreVertical />
        </button>
      </PopOver>
    </div>
  );
};

export default ActionCellContent;
